var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8674 8.43257L9.01268 0.747412C8.94472 0.688818 8.858 0.656006 8.76659 0.656006H6.69237C6.51893 0.656006 6.43925 0.871631 6.5705 0.984131L14.7783 8.10913H1.06268C0.959558 8.10913 0.875183 8.19351 0.875183 8.29663V9.70288C0.875183 9.80601 0.959558 9.89038 1.06268 9.89038H14.776L6.56815 17.0154C6.4369 17.1302 6.51659 17.3435 6.69003 17.3435H8.83456C8.87909 17.3435 8.92362 17.3271 8.95643 17.2966L17.8674 9.56694C17.9485 9.49639 18.0136 9.40925 18.0581 9.3114C18.1027 9.21355 18.1258 9.10728 18.1258 8.99976C18.1258 8.89223 18.1027 8.78596 18.0581 8.68811C18.0136 8.59027 17.9485 8.50312 17.8674 8.43257Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.9cf7381691370b6fe13c5c0070933827.svg";
export { ForwardRef as ReactComponent };